import { Controller } from '@hotwired/stimulus'
import store from '../store'

export default class extends Controller {
  linkClicked(e) {
    e.preventDefault()
    document.getElementById(e.target.getAttribute('href').slice(1)).scrollIntoView({ block: "center" })
    document.getElementById(`section-${this.element.dataset.sectionSqid}-provisions`).scrollIntoView()
    store.selectedSectionSqid.set(this.element.dataset.sectionSqid)
  }
}
